// HeroSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function HeroSection() {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });
  const isMobile = window.innerWidth <= 768;

  const handleClick = () => {
    window.open('/UnityPlayer', '_blank', 'width=1280,height=800');
  };

  return (
    <section
      ref={ref}
      style={{
        height: '100vh',
        scrollSnapAlign: 'start',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(to right, #e0f7fa, #ffffff)',
      }}
    >
      <div style={{ maxWidth: '960px', width: '90%', textAlign: 'center' }}>
        <motion.h1
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
          style={{ fontSize: isMobile ? '6vw' : '48px', fontWeight: 'bold' }}
        >
          시선을 통해 집중력을 이해하다
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          style={{ fontSize: isMobile ? '4vw' : '20px', marginTop: '5vh', color: '#555' }}
        >
          ADHD 아동의 집중력을 스마트폰 하나로 분석하고 훈련합니다.
        </motion.p>
        <motion.button
          onClick={handleClick}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          style={{
            marginTop: '5vh',
            padding: isMobile ? '3vw 6vw' : '12px 24px',
            fontSize: isMobile ? '1rem' : '1.1rem',
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          무료 체험 시작하기
        </motion.button>
      </div>
    </section>
  );
}

export default HeroSection;